export default __webpack_public_path__ + "static/media/token_middle_tablet.3935d64e.png";